module.exports = "<div class=\"loader-wrapper\">\n\t<img src=\"" + require("./loading.gif") + "\">\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/loader/loader.html
// module id = 214
// module chunks = 0